export default __webpack_public_path__ + "static/media/phero.fef1600d.png";